import React from 'react'
import styled from '@emotion/styled'
import { Constants } from '@mobi/settings'
import { colors } from '@mobi/component-library/Foundations'

const LinkStyled = styled.a({
  color: colors.studio[500],
})

const consentTextPart1 =
  "I am authorised to provide the personal information available in the identification documents and application form (passport, driver's licence, Medicare card); and"
const consentTextPart2 =
  'I consent to my personal information being checked with the document issuer or official record holder via third party systems for the purpose of confirming my identity.'
export const consentText = `${consentTextPart1} ${consentTextPart2}`

export const ConsentText = ({ isAmlRiskAssessed }: { isAmlRiskAssessed: boolean }) => {
  const renderedConsentTextPart1 = isAmlRiskAssessed
    ? consentTextPart1.replace(/,\s*Medicare card/, '')
    : consentTextPart1

  return (
    <span style={{ color: colors.neutral[900] }}>
      {renderedConsentTextPart1}
      <br />
      <br />
      {consentTextPart2}
    </span>
  )
}

export const TermsAndConditionsLink = (
  <span style={{ color: colors.neutral[900] }}>
    View TABtouch’s{' '}
    <LinkStyled
      href={Constants.TABtouchTermsAndConditions}
      rel='noopener noreferrer'
      target='_blank'
    >
      Terms and Conditions
    </LinkStyled>
    ,{' '}
    <LinkStyled href={Constants.PrivacyPolicy} rel='noopener noreferrer' target='_blank'>
      Privacy Collection Notice
    </LinkStyled>
  </span>
)
